export default __webpack_public_path__ + "static/media/check.391a2838.svg";